import axios from 'axios';

export const retrieveOnlinePlayers = async () => {
    const response = await axios.get('/onlineplayer');
    return response.data;
};